import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';
import { Paragraph } from '@uncinc/react-drupal-core';
import { WysiwygField, Container, Image } from '../../../../components';

import './style.scss';

const NodeFoundationFull = ({ entity, className }) => {
  const classes = classNames(className);
  return (
    <article typeof="schema:WebPage" className={classes}>
      <div className="FoundationFull full">
        <Container small>
          <h1 className="FoundationFull__title">{entity.getIn(['title', 0, 'value'])}</h1>

          {entity.getIn(['field_image']).size > 0 && (
            <div className="FoundationFull__image">
              <Image
                src={{
                  0: entity.getIn(['field_image', 0, 'styles', 'large']),
                  768: entity.getIn(['field_image', 0, 'styles', 'basic_image']),
                }}
                includeWebP
              />
            </div>
          )}

          {entity.getIn(['body', 0, 'processed']) ? (
            <WysiwygField
              property="schema:text"
              className="FoundationFull__body"
              html={entity.getIn(['body', 0, 'processed'], '')}
            />
          ) : null}
          <div className="Paragraphs">
            {
              entity.getIn(['field_paragraphs'], List()).map((item, index) => {
                const paragraphId = item.get('target_id');
                const paragraph = item.getIn(['entity']);
                return (
                  <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} containerless />
                );
              })
            }
          </div>
        </Container>
      </div>
    </article>
  );
};

export default NodeFoundationFull;
